import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9b27cdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cmpLayer" }
const _hoisted_2 = { style: {"margin":"10px auto","display":"flex","flex-direction":"row","justify-content":"center"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"text-align":"center"} }, "We Care About Your Privacy", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"900"} }, "Our site is supported by personalized advertising shown to you while you visit. Your consent helps make this content available to everyone and your support is appreciated.", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "cmpButtonContainer" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {} }, "Manage Settings", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"-14px"} }, "Accept All", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "cmpSVGButtonArrow",
  "clip-rule": "evenodd",
  "fill-rule": "evenodd",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "2",
  viewBox: "0 0 500 500",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "__cmpIcon",
    d: "M479.3 250L246.5 482.7l-67.1-67L345 250 179.4 84.4l67.1-67.1L479.3 250z"
  })
], -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.logo_URL,
        style: {"max-width":"min(66vw, 400px)","max-height":"72px"}
      }, null, 8, _hoisted_3)
    ]),
    _hoisted_4,
    _hoisted_5,
    _createElementVNode("p", null, [
      _createTextVNode("We and "),
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.vendorsClick && _ctx.vendorsClick(...args)), ["prevent"]))
      }, "our " + _toDisplayString(_ctx.partnerCount) + " partners", 1),
      _createTextVNode(" process personal data such as IP address, unique ID and browsing data for the purposes below:")
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stacks, (stack) => {
      return (_openBlock(), _createElementBlock("p", {
        class: "listdetail",
        key: stack.id+2000
      }, "-- " + _toDisplayString(stack.name), 1))
    }), 128)),
    _createElementVNode("p", null, [
      _createTextVNode("For some of these purposes, we and "),
      _createElementVNode("a", {
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.vendorsClick && _ctx.vendorsClick(...args)), ["prevent"]))
      }, "our partners"),
      _createTextVNode(":")
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature) => {
      return (_openBlock(), _createElementBlock("p", {
        class: "listdetail",
        key: feature.id+1000
      }, "-- " + _toDisplayString(feature.name), 1))
    }), 128)),
    (_ctx.privacyPageURL)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
          _createTextVNode(" Your choices apply only to this site. You may manage specific privacy settings or accept all settings to allow personalized advertising by clicking one of the buttons below. You may adjust your settings at any time in the future by clicking the 'Privacy Choices' link at the bottom of pages on this site or by visiting the "),
          _createElementVNode("a", {
            target: "_blank",
            href: _ctx.privacyPageURL
          }, "privacy policy", 8, _hoisted_7),
          _createTextVNode(" page. ")
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_8, "Your choices apply only to this site. You may manage specific privacy settings or accept all settings to allow personalized advertising by clicking one of the buttons below. You may adjust your settings at any time in the future by clicking the 'Privacy Choices' link at the bottom of pages on this site or by visiting the privacy policy page.")),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("a", {
        class: "cmpButtonLink manageLink",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.manageSettingsClick && _ctx.manageSettingsClick(...args)))
      }, _hoisted_11),
      _createElementVNode("a", {
        class: "cmpButtonLink acceptLink",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.acceptAllClick && _ctx.acceptAllClick(...args))),
        style: {"position":"relative"}
      }, _hoisted_14)
    ])
  ]))
}